import api from "./api";
import auth from "./auth";

const SERVICE_URL_v1 = "punchcard-service/v1";

export default {
  getCampaigns(payload) {
    return new Promise((resolve, reject) => {
      api.post(`${SERVICE_URL_v1}/campaign/list`, payload, auth.getHeader())
        .then(response => {
          return resolve(response);
        })
        .catch(({ status, errors }) => {
          reject({ status, errors });
        });
    });
  },
  getPunchCardRewardsList(payload) {
    return new Promise((resolve, reject) => {
      api.post('rewards-service/v1/campaigns/get-rewards', payload, auth.getHeader())
        .then((response) => resolve(response))
        .catch(({ status, errors }) => reject({ status, errors }));
    });
  },
  punchCardUploadImage(payload) {
    return new Promise((resolve, reject) => {
      api.post(`${SERVICE_URL_v1}/campaign/upload-image`, payload, auth.getHeader())
        .then((response) => resolve(response))
        .catch(({ status, errors }) => reject(status, errors));
    });
  },
  validateCampaignName(payload) {
    return new Promise((resolve, reject) => {
      api.post(`${SERVICE_URL_v1}/campaign/validate-name`, payload, auth.getHeader())
        .then((response) => resolve(response))
        .catch((status, errors) => reject(status, errors));
    });
  },
  createPunchCardCampaign(payload) {
    return new Promise((resolve, reject) => {
      api.post(`${SERVICE_URL_v1}/campaign/create`, payload, auth.getHeader())
        .then((response) => resolve(response))
        .catch((status, errors) => reject(status, errors));
    });
  },
  getPunchCardCampaignDetails(uuid) {
    return new Promise((resolve, reject) => {
      api.get(`${SERVICE_URL_v1}/campaign/view/${uuid}`, auth.getHeader())
        .then((response) => resolve(response))
        .catch((status, errors) => reject(status, errors));
    });
  },
  updatePunchCardCampaign({ uuid, params }) {
    return new Promise((resolve, reject) => {
      api.post(`${SERVICE_URL_v1}/campaign/update/${uuid}`, params, auth.getHeader())
        .then((response) => resolve(response))
        .catch((status, errors) => reject(status, errors));
    });
  }
}